import Form from 'react-bootstrap/Form';

interface ImageFieldProps {
  id: string;
  label: string;
  previewUrl?: string | null;
  onChange: (file: File | null) => void;
  onRemove?: () => void;
  helperText?: string;
  variant?: 'square' | 'wide' | 'avatar';
}

export function ImageField({
  id,
  label,
  previewUrl,
  onChange,
  onRemove,
  helperText,
  variant = 'square',
}: ImageFieldProps) {
  return (
    <Form.Group className="mb-3">
      <Form.Label className="lizzi-form-label">{label}</Form.Label>
      <div className={`lizzi-image-field lizzi-image-field-${variant}`}>
        <div className="lizzi-image-preview">
          {previewUrl ? <img src={previewUrl} alt="" /> : <span>Sem imagem</span>}
        </div>
        <div className="lizzi-image-actions">
          <Form.Control
            id={id}
            type="file"
            accept="image/png,image/jpeg,image/webp"
            className="lizzi-form-control"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.files?.[0] ?? null)}
          />
          <div className="lizzi-image-actions-row">
            {helperText ? <small>{helperText}</small> : <span />}
            {previewUrl && onRemove ? (
              <button type="button" className="lizzi-link-button" onClick={onRemove}>
                Remover
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </Form.Group>
  );
}
